const DiscordIcon = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 28 20"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_55_2318)">
        <path
          stroke="none"
          d="M24.1199 2.74496C22.2699 1.29496 20.0099 0.444961 17.6599 0.334961L17.3399 0.704961C19.4299 1.26496 21.3799 2.25496 23.0599 3.62496C20.9199 2.44496 18.5699 1.69496 16.1399 1.41496C14.5999 1.24496 13.0399 1.26496 11.4899 1.46496C9.54995 1.64496 7.64995 2.15496 5.87995 2.96496C5.02995 3.35496 4.51995 3.63496 4.51995 3.63496C6.29995 2.19496 8.35995 1.16496 10.5699 0.614961L10.3399 0.334961C7.98995 0.454961 5.72995 1.29496 3.87995 2.74496C1.77995 6.91496 0.639946 11.505 0.569946 16.165C0.569946 16.165 2.49995 19.495 7.57995 19.665C7.57995 19.665 8.42995 18.635 9.11995 17.755C7.49995 17.345 6.07995 16.385 5.09995 15.045C6.92995 16.205 8.96995 17.005 11.0999 17.395C13.0699 17.775 15.0899 17.785 17.0599 17.415C19.1899 17.025 21.2199 16.235 23.0399 15.065C22.0199 16.435 20.5399 17.405 18.8799 17.805C19.5699 18.675 20.3999 19.665 20.3999 19.665C25.4799 19.505 27.4399 16.165 27.4399 16.165C27.3699 11.505 26.2299 6.91496 24.1299 2.75496L24.1199 2.74496ZM9.69995 14.005C8.28995 13.885 7.23995 12.645 7.35995 11.235C7.45995 9.98496 8.44995 9.00496 9.69995 8.89496C11.1099 9.01496 12.1599 10.255 12.0399 11.665C11.9399 12.915 10.9499 13.895 9.69995 14.005ZM18.0999 14.005C16.6899 14.125 15.4499 13.075 15.3299 11.665C15.2099 10.255 16.2599 9.01496 17.6699 8.89496C19.0799 8.77496 20.3199 9.82496 20.4399 11.235C20.4399 11.305 20.4399 11.375 20.4399 11.455C20.4899 12.805 19.4399 13.945 18.0899 14.005H18.0999Z"
          fill="inherit"
        />
      </g>
      <defs>
        <clipPath id="clip0_55_2318">
          <rect
            stroke="none"
            width="26.86"
            height="19.33"
            fill="inherit"
            transform="translate(0.569946 0.334961)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default DiscordIcon
